import { render, staticRenderFns } from "./TabMotor.vue?vue&type=template&id=75be280a&"
import script from "./TabMotor.vue?vue&type=script&lang=js&"
export * from "./TabMotor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports